import { CContainer } from '@coreui/react'
import React from 'react'
import { Route, Routes } from 'react-router-dom'
import Privada from 'routes/Privada'
import { routes } from 'routes/rutas'

export const Contenido = () => {
    return (
        <CContainer fluid className='mb-4' >
            <Routes>
                {routes.map((route, i) => {
                    return (
                        route.element && (
                            <Route
                                key={i}
                                path={route.path}
                                element={
                                    <Privada allowedRoles={route.allowedRoles}>
                                        <route.element />
                                    </Privada>
                                }
                            />
                        )
                    )

                })}
            </Routes>
        </CContainer>
    )
}
